import { useCallback, useState } from "react";

import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Button, ButtonLink } from "simplydo/react/ui/button";
import { Divider } from "simplydo/react/ui/divider";
import { H2, Subheader } from "simplydo/react/ui/header";
import { Input } from "simplydo/react/ui/input";
import {
  Message,
  MessageContent,
  MessageHeader,
} from "simplydo/react/ui/message";

import actions from "actions";
import api from "api";
import { useAppDispatch, useAppSelector } from "store";

function ResetPassword() {
  const { t } = useTranslation();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const error = useAppSelector((state) => state.entry.error);

  const dispatch = useAppDispatch();
  const setError = useCallback(
    (value: string) => {
      dispatch(actions.entry.updateError(value));
    },
    [dispatch],
  );

  const navigate = useNavigate();

  const [params] = useSearchParams();
  const token = params.get("token");

  const resetPassword = () => {
    if (!token) {
      return;
    }
    setLoading(true);
    setError("");
    api.auth.updatePasswordWithToken(
      token,
      password,
      () => {
        setLoading(false);
        toast(t("entry.resetPassword.success"));
        navigate("/");
      },
      (err) => {
        setLoading(false);
        setError(err.message);
      },
    );
  };

  if (!token || error) {
    return (
      <>
        <H2>Password reset</H2>
        <Message color="red">
          <MessageHeader>
            {error || t("entry.resetPassword.invalidToken.title")}
          </MessageHeader>
          <MessageContent>
            {t("entry.resetPassword.invalidToken.message")}
          </MessageContent>
        </Message>
        <div style={{ textAlign: "center", marginTop: 36 }}>
          <ButtonLink color="primary" to="/">
            {t("entry.returnToLogin")}
          </ButtonLink>
        </div>
      </>
    );
  }

  return (
    <div>
      <H2>
        Password reset
        <Subheader>{t("entry.resetPassword.info")}</Subheader>
      </H2>
      <Divider hidden />
      <Input
        fluid
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        autoFocus
        placeholder={t("entry.login.password")}
      />
      <div style={{ marginTop: 30, textAlign: "right" }}>
        <Button onClick={resetPassword} loading={loading} color="primary">
          {t("entry.resetPassword.change")}
        </Button>
      </div>
    </div>
  );
}

export default ResetPassword;
